import React, { Component } from 'react'
import Select from 'react-select'

class EmployeeAttritionStatus extends Component {
    constructor() {
        super()
        this.state = {
            employeeAttritionStatusList:[ {"label":"OPEN","value":"OPEN"},{"label":"CLOSED","value":"CLOSED"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.employeeAttritionStatusList}
                placeholder="Select Status"
                onChange={(e) => { (e) ? this.props.attritionStatusChange(e) : this.props.attritionStatusChange([])}}
                />
            </div>
        )
    }
}

export default EmployeeAttritionStatus


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/EmployeeAttritionStatus.js